import { vdkEmHappinessPortalApi } from './vdk-em-happiness-portal-api';
const createMVP = (payload) => {
    return vdkEmHappinessPortalApi.post('/mvps/create', payload);
};
const createExternalMVPs = (payload) => {
    return vdkEmHappinessPortalApi.post('/mvps/create-external', payload);
};
const createExternalRelationAndAddToMVP = (payload) => {
    return vdkEmHappinessPortalApi.post('/mvps/create-external-relation-and-add-to-mvp', payload);
};
const updateMVP = (payload) => {
    return vdkEmHappinessPortalApi.put('/mvps/update', payload);
};
const updateExternalMVP = (id, payload) => {
    return vdkEmHappinessPortalApi.put(`/mvps/external/${id}`, payload);
};
const getAllMVPs = (payload) => {
    return vdkEmHappinessPortalApi.post('/mvps/get-all', payload);
};
const getMVPById = (id) => {
    return vdkEmHappinessPortalApi.get(`/mvps/${id}`);
};
const deleteMVP = (id) => {
    return vdkEmHappinessPortalApi.delete(`/mvps/${id}`);
};
const downloadExcelTemplate = () => {
    return vdkEmHappinessPortalApi.get('/mvp/download-excel-template', {
        responseType: 'blob'
    });
};
const uploadExcel = (file, eventId) => {
    const formData = new FormData();
    formData.append('File', file);
    formData.append('EventId', eventId);
    return vdkEmHappinessPortalApi.post('/mvp/upload-excel', formData, {
        headers: {
            'Content-Type': 'multipart/form-data'
        }
    });
};
const sendInvitation = (id) => {
    return vdkEmHappinessPortalApi.post(`/mvps/${id}/send-invitation`);
};
const sendReinvitationEmail = (id) => {
    return vdkEmHappinessPortalApi.post(`/mvps/${id}/send-reinvitation-email`);
};
const sendInvitationsBulk = (payload) => {
    return vdkEmHappinessPortalApi.post('/mvps/send-invitations', payload);
};
const exportInvitedMVPs = (eventId) => vdkEmHappinessPortalApi.get(`/mvps/events/${eventId}/export-invited`);
const MVPsApi = {
    createMVP,
    createExternalMVPs,
    createExternalRelationAndAddToMVP,
    updateMVP,
    updateExternalMVP,
    getAllMVPs,
    getMVPById,
    deleteMVP,
    downloadExcelTemplate,
    uploadExcel,
    sendInvitation,
    sendReinvitationEmail,
    sendInvitationsBulk,
    exportInvitedMVPs
};
export default MVPsApi;
